import React from 'react';
import { Link } from 'react-router-dom';

export const ShippingPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="shipping-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-['Bodoni_Moda'] text-4xl font-bold text-[#2A2A2A] mb-8">
          Shipping Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#444]">
          <p className="text-sm text-[#666] mb-8">Last updated: January 2026</p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Processing Time
          </h2>
          <p>
            Orders are processed within 1-2 business days. Orders placed on weekends or holidays will be processed on the next business day.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Shipping Methods & Times
          </h2>
          <div className="bg-white rounded-xl border border-[#E5E0D8] overflow-hidden my-6">
            <table className="w-full">
              <thead>
                <tr className="bg-[#F5F3F0]">
                  <th className="text-left p-4 font-semibold text-[#2A2A2A]">Method</th>
                  <th className="text-left p-4 font-semibold text-[#2A2A2A]">Estimated Time</th>
                  <th className="text-left p-4 font-semibold text-[#2A2A2A]">Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-[#E5E0D8]">
                  <td className="p-4">Standard Shipping</td>
                  <td className="p-4">3-5 business days</td>
                  <td className="p-4">$5.99</td>
                </tr>
                <tr className="border-t border-[#E5E0D8]">
                  <td className="p-4">Expedited Shipping</td>
                  <td className="p-4">2-3 business days</td>
                  <td className="p-4">$9.99</td>
                </tr>
                <tr className="border-t border-[#E5E0D8]">
                  <td className="p-4">Overnight Shipping</td>
                  <td className="p-4">1 business day</td>
                  <td className="p-4">$19.99</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Shipping Locations
          </h2>
          <p>
            We currently ship to all 50 U.S. states. International shipping is not available at this time but is coming soon!
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Order Tracking
          </h2>
          <p>
            Once your order ships, you'll receive a confirmation email with tracking information. You can use this to monitor your package's journey to your door.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Issues with Your Order?
          </h2>
          <p>
            If your package is lost, damaged, or hasn't arrived within the expected timeframe, please{' '}
            <Link to="/contact" className="text-[#D4540A] hover:underline">
              contact us
            </Link>{' '}
            and we'll make it right.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPage;
